export const formatCUIT = (cuit: string): string => {
  let numericCuit = cuit.replace(/\D/g, "");
  if (numericCuit.length > 11) {
    numericCuit = numericCuit.slice(0, 11);
  }

  // Si tiene 8 o menos dígitos, lo tratamos como DNI (sin formato).
  if (numericCuit.length <= 8) {
    return numericCuit;
  }

  const formattedCuit = numericCuit.replace(/^(\d{2})(\d{8})(\d)$/, "$1-$2-$3");

  return formattedCuit;
};

export const validarDni = (dni: string): string => {
  const numericDni = dni.replace(/\D/g, "");
  if (numericDni.length < 7 || numericDni.length > 8) {
    return "Tu DNI debe tener 7 u 8 dígitos numéricos";
  }
  return "";
};

export const validarCuit = (cuit: string): string => {
  if (cuit.length !== 13) return "Tu CUIL/CUIT debe tener 11 dígitos numéricos";

  const numericCuit = cuit.replace(/[^0-9]/g, "");
  //Validación si es un extranjero (numero de cuit fijo y ramdom)
  if (numericCuit === "99001982239") {
    return "";
  } else {
    const tiposValidos = ["20", "23", "24", "25", "26", "27", "30", "33", "34"];
    if (!tiposValidos.includes(numericCuit.substring(0, 2)))
      return "El tipo de CUIT/CUIL no es válido.";

    const multiplicadores = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let suma = 0;
    for (let i = 0; i < 10; i++) {
      suma += parseInt(numericCuit[i], 10) * multiplicadores[i];
    }

    const resto = suma % 11;
    const digitoVerificador = resto === 0 ? 0 : resto === 1 ? 9 : 11 - resto;

    if (digitoVerificador !== parseInt(numericCuit[10], 10)) {
      return "El dígito verificador del CUIT/CUIL no es válido.";
    }
  }
  return "";
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex =
    /^[a-zA-Z0-9._%+-ñÑáéíóúÁÉÍÓÚ]*@[a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const validateField = (
  field: "email" | "cuit",
  value: string
): string => {
  const validators: Record<"email" | "cuit", (value: string) => string> = {
    email: (value) => {
      if (!value.trim()) return "Completá tu email para ingresar.";
      if (!isValidEmail(value))
        return "Por favor, revisá tu email y volvé a intentar.";
      return "";
    },
    cuit: (value) => {
      if (!value.trim()) return "Completá tu DNI o CUIT para ingresar.";
      const numeric = value.replace(/\D/g, "");

      // DNI: 7 u 8 dígitos
      if (numeric.length <= 8) {
        return validarDni(numeric);
      }

      // CUIT: 11 dígitos
      const formattedCuit = formatCUIT(value);
      if (formattedCuit.length !== 13)
        return "Ingresá un DNI (7-8 dígitos) o CUIT (11 dígitos) válido";
      return validarCuit(formattedCuit);
    },
  };

  return validators[field](value);
};
